<template>
<div class="english eng-select-holder" style="padding-top: 4px;">
  <xui-select
      class="text-left"
      :disabled='disabled'
      :hasSearch="hasSearch || false" 
      :placeholder="placeholder || 'Select...'"
      :label="label || ''"
      :options="items"
      :keys="{id: optionKey, label:  optionLabel}"
      v-model="selectedItem"
      @input="updateValue"
      :type="type || 'basic'"
  ></xui-select>
  <div v-for="error in myErrors" :key="error">{{error}}</div>
</div>
</template>

<script>
import axios from '@/plugins/axios'
import UiSelect from './UiSelect.vue'

export default {
  name: 'NewSelect',
  data () {
    return {
      items: [],
      selectedItem: {},
      myErrors: [],
      myLabel: ''
    }
  },

  components: {
    'xui-select': UiSelect
  },

  props: [
    'label',
    'value',
    'url',
    'placeholder',
    'optionLabel',
    'optionKey',
    'options',
    'type',
    'disabled',
    'hasSearch',
    'mode',
  ],



  computed: {
  },

  methods: {
    loadOptions() {
        let url = (typeof this.url == 'function') ?
                    this.url() :
                        this.url;
                    
      axios.get(url).then((resp) => {
        this.items = resp.data
      }) 
    },

    updateValue(value) {
      if (this.mode == 'object') {
        this.$emit('input', value)
      } else {
        this.$emit('input', value[this.optionKey])
      }
      // this.$emit('input', value[this.optionKey])
    },

    updateValueFromParent(newValue) {

      // TODO:: refactor selctedItems to be a computed item with setter and getter
      // and remove watch for items and options ?
      if (this.mode == 'object') {
        this.selectedItem = newValue
      } else {
        if(this.items) {
          this.selectedItem = this.items.find(item => item[this.optionKey] == newValue) || {}  
        } else {
          this.selectedItem = {}
        }
      }
      
    },

    updateOptionsFromParent(newValue) {
      this.items = newValue || []
    }
    

  },
  watch: {
    value: function(newValue, oldValue) {
      this.updateValueFromParent(newValue)
    },
    options: function(newValue, oldValue) {
      this.updateOptionsFromParent(newValue)
    },
    items:function() {
      this.updateValueFromParent(this.value)
    }
  },
  created() {
   
    this.updateOptionsFromParent(this.options)
    this.updateValueFromParent(this.value)
    if(this.url) {
      this.loadOptions()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.eng-select-holder >>> .ui-select__options .ui-select-option{
  /* color: gray; */
  /* font-size: 13px !important; */
  font-family: Roboto, -apple-system, BlinkMacSystemFont, "Segoe UI", Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol" !important;
}

/* .ui-select-option .ui-select-option--type-basic {
  text-align: left !important;
    direction: ltr !important;
  width: 100% !important;
} */

li>div.ui-select-option__basic {
  text-align: left !important;
  direction: ltr !important;
  width: 100% !important;
}

.eng-select-holder >>> .ui-select__display-value{
  padding-right: 5px;
  padding-left: 5px;
  /* font-size: 13px; */
  text-align: left;
  /* color: gray; */
  font-family: Roboto, -apple-system, BlinkMacSystemFont, "Segoe UI", Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol" !important;

}
.error {
  color: red;
}

.report-form {
  height: 50vh;
}

.actions {
  display: flex;
  align-content: center;
}
</style>
